import { Zap } from "lucide-react";

// Wechselrichter-Check: Modulleistung (kWp) / Wechselrichter-Leistung (kW), ok von 0,7 bis 1,5.
export const RATIO_MIN = 0.7;
export const RATIO_MAX = 1.5;
const de = (v, d = 1) => Number(v).toLocaleString("de-DE", { minimumFractionDigits: d, maximumFractionDigits: d });

export const inverterCheck = (items, catalog) => {
  const byId = Object.fromEntries((catalog || []).map((c) => [c.id, c]));
  let kwp = 0;
  let kw = 0;
  for (const it of items || []) {
    const c = byId[it.component_id];
    if (!c || it.is_free) continue;
    const sum = (Number(it.qty) || 0) * (Number(c.kwp_or_kw) || 0);
    if (c.type === "module") kwp += sum;
    if (c.type === "inverter") kw += sum;
  }
  if (!kwp || !kw) return null;
  const ratio = kwp / kw;
  const status = ratio > RATIO_MAX ? "too_small" : ratio < RATIO_MIN ? "too_large" : "ok";
  return { kwp, kw, ratio, status };
};

const message = (r) => (r.status === "too_small"
  ? "Wechselrichter evtl. zu klein"
  : "Wechselrichter evtl. zu groß");

export function InverterWarning({ items, catalog, testid }) {
  const r = inverterCheck(items, catalog);
  if (!r || r.status === "ok") return null;
  return (
    <div className="rounded-lg border border-amber-500/50 bg-amber-500/10 px-3 py-2 flex items-start gap-2 text-[12.5px] text-amber-100" data-testid={testid}>
      <Zap size={15} className="text-amber-300 shrink-0 mt-0.5" />
      <span>
        <b>{message(r)}:</b> {de(r.kwp, 2)} kWp Module an {de(r.kw)} kW Wechselrichter (Verhältnis {de(r.ratio, 2)}, sinnvoll {de(RATIO_MIN)}–{de(RATIO_MAX)}).
        {r.status === "too_small" ? " Größeren Wechselrichter wählen oder Module reduzieren." : " Kleineren Wechselrichter wählen oder Module ergänzen."}
      </span>
    </div>
  );
}

export function InverterBadge({ items, catalog, testid }) {
  const r = inverterCheck(items, catalog);
  if (!r || r.status === "ok") return null;
  return (
    <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-amber-500/20 border border-amber-500/40 text-amber-300 text-[10.5px] font-semibold"
      title={`${de(r.kwp, 2)} kWp an ${de(r.kw)} kW (Verhältnis ${de(r.ratio, 2)}, sinnvoll ${de(RATIO_MIN)}–${de(RATIO_MAX)})`} data-testid={testid}>
      <Zap size={11} /> {message(r)} ({de(r.ratio, 2)})
    </span>
  );
}
